module.exports = __webpack_public_path__ + "img/KR.d591bacc.svg";